<script context="module">
    import {addModal} from '../Components/ModalManager.svelte';
    import FormModal from "./FormModal.svelte";

    export function addFormModal(modal) {
        if (modal.data) {
            modal.data = JSON.parse(JSON.stringify(modal.data));
        }

        return addModal(FormModal, modal);
    }

    export function closeModal(id) {
        modals.update(m => m.filter((i) => i.id != id))
    }

</script>